// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_item-module--container--3vTQa"};